<template>
  <div>
    <section class="content">
      <div class="row">
        <div class="col-sm-12">
          <div class="box box-default box-solid box-component">
            <div class="box-body box-details-header">
              <div class="details-header">
                <div class="details-header--details">
                  <h2>Dane banku</h2>
                  <ul class="list-unstyled">
                    <li><label>Nazwa:</label> {{ bank.label }}</li>
                    <li><label>Województwo:</label> {{ voivodeshipName }}</li>
                    <li><label>Miejscowość:</label> {{ bank.city }}</li>
                    <li><label>Kod pocztowy:</label> {{ bank.postcode }}</li>
                    <li><label>Adres:</label> {{ bank.street }}</li>
                    <li><label>e-mail:</label> {{ bank.email }}</li>
                    <li><label>Telefon:</label> {{ bank.phone }}</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Modals -->
    <bank-edit-modal
      :show="bankEditVisible"
      :form-data="bank"
      @close="bankEditVisible = false"
      @success="bankEdited"
    />
  </div>
</template>

<script>
import api from '../../../../../api'
import DynamicBreadcrumb from '../../../share/mixins/DynamicBreadcrumb'
import BankEditModal from './modal/BankEdit'
import Page from '../../../../share/content/Page'

export default {
  components: {
    BankEditModal
  },
  mixins: [
    DynamicBreadcrumb,
    Page
  ],
  data () {
    return {
      events: {
        editBank: 'core:bank:editBank'
      },
      headerTitle: { title: 'Bank', description: 'Szczegóły' },
      bankEditVisible: false,
      actionEditName: 'bank_edit',
      urlActions: {
        getContent: { method: 'get', url: `/bank/${this.$route.params.id}` }
      },
      bank: {
        label: '',
        voivodeship: '',
        city: '',
        postcode: '',
        street: '',
        email: '',
        phone: ''
      }
    }
  },
  computed: {
    voivodeshipName () {
      if (this.$store.state.base.voivodeships.length !== 0 && this.bank.voivodeship !== '') {
        return this.$store.state.base.voivodeships.filter(v => v.value.toString() === this.bank.voivodeship.toString())[0].label
      } else {
        return ''
      }
    }
  },
  mounted () {
    this.$events.on(this.events.editBank, this.editBank)

    this.$nextTick(() => {
      this.loadContent()
    })
  },
  methods: {
    editBank () {
      this.bankEditVisible = true
    },
    loadContent () {
      this.toggleLoading()

      api.request('core', this.urlActions.getContent.method, this.urlActions.getContent.url)
        .then((response) => {
          this.toggleLoading()
          let data = response.data.bank
          this.bank = data
          this.bank.voivodeship = data.voivodeship.id

          // dynamic breadcrumb labels
          this.addDynamicBreadcrumbLabel(this.$route.name, this.bank.label)

          this.dataLoaded = true
        })
        .catch(() => {
          this.toggleLoading()
        })
    },
    bankEdited (bank) {
      this.bank = bank
    }
  }
}
</script>

<style scoped>
    .label {
        display: inline-block;
        margin-bottom: 0.3em;
        vertical-align: middle;
    }
</style>
